import { mapArrayField, mapDateField } from "~/v2/mappers/vaas-helpers"
import type {
  RawLearningCue,
  VaasOption,
  VaasQuestion,
  VaasQuestionSet,
} from "~/v2/types/vaas"

const mapOption = (option: any): VaasOption => ({
  ...option,
  id: option?.id ?? null,
  name: option?.name ?? "",
})

const mapSet = (set: any): VaasQuestionSet => ({
  ...set,
  correct_option_id: set?.correct_option_id ?? "",
  id: set?.id ?? null,
  options: mapArrayField(set?.options).map(mapOption),
})

const mapQuestion = (question: any): VaasQuestion => ({
  ...question,
  explanation: question?.explanation ?? "",
  id: question?.id ?? null,
  image: question?.image ?? "",
  image_title: question?.image_title ?? "",
  name: question?.name ?? "",
  sets: mapArrayField(question?.sets).map(mapSet),
  type: question?.type ?? "multiple_choice",
})

const mapKnowledgeCheck = (knowledgeCheck: any) => {
  if (!knowledgeCheck) {
    return null
  }

  return {
    ...knowledgeCheck,
    id: knowledgeCheck?.id ?? null,
    questions: mapArrayField(knowledgeCheck?.questions).map(mapQuestion),
  }
}

const mapSentimentQuestions = (questions: unknown): VaasQuestion[] =>
  mapArrayField(questions).map(mapQuestion)

const mapVaasLearningCue = (cue: any): RawLearningCue | null => {
  if (!cue) {
    return null
  }

  return {
    ...cue,
    created: mapDateField(cue?.created),
    force_pause: cue?.force_pause === 1 || cue?.force_pause === true,
    fullscreen: cue?.fullscreen === 1 || cue?.fullscreen === true,
    knowledgeCheck: mapKnowledgeCheck(cue?.knowledgeCheck),
    sentimentQuestions: mapSentimentQuestions(cue?.sentimentQuestions),
    start_seconds:
      cue?.start_seconds === null || cue?.start_seconds === undefined
        ? 0
        : Number(cue.start_seconds),
    updated: mapDateField(cue?.updated),
  }
}

const mapVaasLearningCueList = (cues: unknown): RawLearningCue[] =>
  mapArrayField(cues)
    .map(mapVaasLearningCue)
    .filter(Boolean) as RawLearningCue[]

export { mapVaasLearningCue, mapVaasLearningCueList }
